import React from 'react';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <header className="privacy-headers">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: December 10, 2025</p>
      </header>

      <div className="privacy-content">
        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Humanex. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our HR management platform.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Information</h3>
          <p>
            We collect information that you provide directly to us, including but not limited to: name, email address, phone number, job title, company information, employee records, payroll data, performance reviews, and other HR-related information.
          </p>
          
          <h3>2.2 Automatically Collected Information</h3>
          <p>
            When you access our platform, we automatically collect certain information including IP address, browser type, operating system, access times, pages viewed, and the page you visited before navigating to our platform.
          </p>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information for various purposes including:</p>
          <ul>
            <li>Providing and maintaining our HR management services</li>
            <li>Processing employment-related transactions and records</li>
            <li>Improving and personalizing user experience</li>
            <li>Communicating with you about updates, security alerts, and support</li>
            <li>Ensuring compliance with legal obligations</li>
            <li>Detecting and preventing fraud or security breaches</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. This includes encryption, secure servers, regular security audits, and access controls. However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Data Sharing and Disclosure</h2>
          <p>
            We do not sell your personal information. We may share your information with trusted third-party service providers who assist us in operating our platform, conducting our business, or servicing you, provided they agree to keep this information confidential. We may also disclose information when required by law or to protect our rights.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate or incomplete information</li>
            <li>Request deletion of your personal information</li>
            <li>Object to or restrict processing of your information</li>
            <li>Data portability</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>7. Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, comply with legal obligations, resolve disputes, and enforce our agreements.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our platform and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </p>
        </section>

        <section className="privacy-section">
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="privacy-section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us at:
          </p>
          <div className="contact-info">
            <p><strong>Email:</strong> support@devopstrioglobal.com</p>
            <p><strong>Phone:</strong> +1 (555) 123-4567</p>
            <p><strong>Address:</strong> 128 City Road, London, EC1V NX United Kingdom</p>
          </div>
        </section>
      </div>

      {/* <footer className="privacy-footer">
        <p>© 2025 Humanex. All rights reserved.</p>
      </footer> */}
    </div>
  );
}